export default "__VITE_ASSET__B6aV0oG4__"